import { BUSINESS_ROUTE, URGENT_ROUTE } from 'data/global';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import HomeIcon from 'icons/Home.icon';

export default function useUrgentCampaigns() {
  const { t } = useTranslation();

  const breadcrumbsLinks = useMemo(
    () => [
      {
        icon: HomeIcon,
        to: BUSINESS_ROUTE,
        text: t('home'),
      },
      {
        to: URGENT_ROUTE,
        text: t('urgentListings'),
      },
    ],
    [t],
  );

  return { breadcrumbsLinks };
}
